<div class="c-loader c-loader--blocks">
	<div class="c-loader__block"></div>
	<div class="c-loader__block"></div>
	<div class="c-loader__block"></div>
	<div class="c-loader__block"></div>
</div>
